import actions from './actions';
import initialState from '../../initialState';

export const ruleReducer = (state = initialState.rules, action) => {
    switch (action.type) {
        case actions.SET_RULE_MODAL:
            return { ...state, ruleModal: action.state.ruleModal };
        case actions.SET_SUPPLEMENTAL_RULE_MODAL:
            return {
                ...state,
                supplementalruleModal: action.state.supplementalruleModal,
            };
        default:
            return { ...state };
    }
};

export default ruleReducer;
